export async function getMimsClasses() {
    //returns all  classes including Main and Sub Class hierarchy
    //console.log(`Bearer ${localStorage.getItem('token').replaceAll('"', "")}`)
    let url = 'https://sqn72kk00l.execute-api.ap-southeast-2.amazonaws.com/prod'
    try
    {
        return await fetch(`${url}/mimsClass/mainClass`,
        {
            headers: {
                'Authorization':`Bearer ${localStorage.getItem('token').replaceAll('"', "")}`
            }
        })
        .then(data => data.json())
    }
    catch(error)
    {
        return [];
    }
}